import React from "react";
import { PageHero, SectionLabel } from "@/components/Sections";
import QuoteForm from "@/components/QuoteForm";
import { COMPANY, ASSETS } from "@/lib/data";
import { MapPin, Mail, Phone, Clock } from "lucide-react";

export default function Kontakt() {
  return (
    <>
      <PageHero
        eyebrow="Kontakt"
        title="Skicka en offertförfrågan"
        intro="Berätta kort vad ni behöver hjälp med, så återkommer Rena Tjänster med mer information. Vi utgår från Bjuv och hjälper företag och verksamheter i hela nordvästra Skåne – bland annat i Helsingborg, Höganäs, Ängelholm, Båstad, Örkelljunga, Perstorp, Klippan, Svalöv, Landskrona och Åstorp."
        image={ASSETS.quoteContact}
        imageAlt="Kontorsstädning av Rena Tjänster"
      />

      <section className="py-20 lg:py-28" data-testid="kontakt-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-5 gap-12">
          <aside className="lg:col-span-2 space-y-4">
            <SectionLabel className="mb-2">Hitta oss</SectionLabel>
            <div className="bg-white rounded-2xl p-6 border border-slate-100" data-testid="kontakt-card-address">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-[#1E3A6F]/8 text-[#1E3A6F] inline-flex items-center justify-center flex-shrink-0">
                  <MapPin className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <div>
                  <p className="text-xs text-slate-500 mb-1">Adress</p>
                  <p className="font-display font-semibold text-slate-900">{COMPANY.address}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-100" data-testid="kontakt-card-email">
              <a href={`mailto:${COMPANY.email}`} className="flex items-start gap-4 hover:text-[#1E3A6F]">
                <div className="w-11 h-11 rounded-xl bg-[#1E3A6F]/8 text-[#1E3A6F] inline-flex items-center justify-center flex-shrink-0">
                  <Mail className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <div>
                  <p className="text-xs text-slate-500 mb-1">E-post</p>
                  <p className="font-display font-semibold text-slate-900">{COMPANY.email}</p>
                </div>
              </a>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-slate-100" data-testid="kontakt-card-phone">
              <a href={COMPANY.phoneLink} className="flex items-start gap-4 hover:text-[#1E3A6F]">
                <div className="w-11 h-11 rounded-xl bg-[#1E3A6F]/8 text-[#1E3A6F] inline-flex items-center justify-center flex-shrink-0">
                  <Phone className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <div>
                  <p className="text-xs text-slate-500 mb-1">Telefon</p>
                  <p className="font-display font-semibold text-slate-900">{COMPANY.phone}</p>
                </div>
              </a>
            </div>

            <div className="bg-[#1E3A6F] text-white rounded-2xl p-6 relative overflow-hidden" data-testid="kontakt-card-hours">
              <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-[#F59E0B]/20 blur-3xl" />
              <div className="flex items-start gap-4 relative">
                <div className="w-11 h-11 rounded-xl bg-white/10 text-[#F59E0B] inline-flex items-center justify-center flex-shrink-0">
                  <Clock className="h-5 w-5" strokeWidth={1.6} />
                </div>
                <div>
                  <p className="text-xs text-white/70 mb-1">Svarstid</p>
                  <p className="font-display font-semibold">Vi återkommer så snart vi kan</p>
                </div>
              </div>
            </div>
          </aside>

          <div className="lg:col-span-3">
            <QuoteForm />
          </div>
        </div>
      </section>
    </>
  );
}
